import { render } from "./OverlayBrowser.vue?vue&type=template&id=03824bf8&scoped=true"
import script from "./OverlayBrowser.vue?vue&type=script&lang=js"
export * from "./OverlayBrowser.vue?vue&type=script&lang=js"

import "./OverlayBrowser.vue?vue&type=style&index=0&id=03824bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03824bf8"]])

export default __exports__